import { data } from 'currency-codes';

export const CURRENCY_CODE_CHOICES = data.map((currency) => ({
  id: currency.code,
  name: `${currency.code} (${currency.currency})`,
}));
